export const bannerEmojiCircle =
  'flex size-10 shrink-0 items-center justify-center rounded-full p-3 text-display-xs lg:size-14 lg:p-2';

export const bannerEmojiBg = {
  brand: 'bg-bg-brand-primary_alt',
  warning: 'bg-warning-secondary',
  success: 'bg-success-secondary',
} as const;

export const bannerEmojiLgText = {
  sm: 'lg:text-3xl',
  md: 'lg:text-4xl',
} as const;
